import NavbarComponent from "./Navbar"
import FooterComponent from "./Footer"
import { useState } from "react"
import { Link, useNavigate } from 'react-router-dom'
import { COMMON_CONSTANTS } from '../constants/Common'
import { AXIOS_HELPERS } from '../helpers/Axios'
import Seo from "../components/Seo"
import('../css/Footer.css')
import('../css/Navbar.css')
import('../css/Login.css')

const { config: { base_url } } = COMMON_CONSTANTS
const { MakeAxiosCall } = AXIOS_HELPERS

// const base_url = process.env.REACT_APP_API_BASE_URL
// const base_url = "https://www.codingsikho.online/api/v1"


const Login = () => {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [errMessage, setErrorMesage] = useState("")
    const [user, setUser] = useState(null)

    const navigate = useNavigate()

    const handleSubmit = async (e) => {
        e.preventDefault();
        const options = {
            method: "POST",
            url: `${base_url}/signin`,
            headers: {
                "Content-Type": "application/json"
            },
            data: {
                email, password
            }

        }

        try {
            console.log('base url', base_url)
            const response = await MakeAxiosCall(options)
            // console.log('response------', response.data)
            if (response?.data?.data?.status === false) {
                setErrorMesage(response.data.data.message)
                // alert(response.data.data.message)
            } else {
                setUser(response?.data?.data)
                // console.log('userinfo===========>', user, 'response---------', response.data.data.userInfo)
                localStorage.setItem('user', JSON.stringify(response?.data?.data?.userInfo))
                localStorage.setItem('isLoggedIn', true)
                navigate('/landlist')
            }
        } catch (error) {
            console.log('error in login catch block')
            if (error?.respons?.data) {
                alert('Invalid Email or Password')
            }

        }


    };


    return (
        <>
            <Seo
                title="Login - KhetBazaar"
                description="Login to your KhetBazaar account to manage land listings and transactions."
                canonical="https://khetbazaar.in/login"
            />

            <NavbarComponent
                userInfo={user}
            />
            <div className="signin-container">
                <form className="signin-form" onSubmit={handleSubmit}>
                    <div className="form-content">
                        <h2>Sign In</h2>
                        {errMessage && (<h3 style={{ color: "red", fontSize: "16px", textAlign: "center" }}>{errMessage}</h3>)}
                        <div className="form-group-signin">
                            <label htmlFor="email">Email Address</label>
                            <input
                                type="email"
                                id="email"
                                placeholder="Enter your email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>

                        <div className="form-group-signin">
                            <label htmlFor="password">Password</label>
                            <input
                                type="password"
                                id="password"
                                placeholder="Enter your password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>

                        <button type="submit" className="signin-button">
                            Sign In
                        </button>
                        <div className="form-group forgot-password">
                            <Link to="/forgot-password">Forgot Password?</Link>
                        </div>


                        <div className="register-link">
                            Don't have an account? <Link to="/signup">Register here</Link>
                        </div>
                    </div>

                </form>
            </div>
            <FooterComponent />
        </>
    )
}


export default Login